var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "text",
        { staticClass: "marker-label", attrs: { x: _vm.x, y: _vm.y } },
        [
          !_vm.showCount
            ? [
                _c(
                  "tspan",
                  {
                    attrs: {
                      "font-size": 18 * _vm.sizeScale,
                      "stroke-width": 3 * _vm.sizeScale,
                      stroke: "white",
                      fill: "#333",
                      "paint-order": "stroke fill",
                      "dominant-baseline": "middle",
                      "font-weight": "bold",
                    },
                  },
                  [_vm._v("\n      " + _vm._s(_vm.truncatedLabel) + "\n    ")]
                ),
              ]
            : [
                _c(
                  "tspan",
                  {
                    attrs: {
                      x: _vm.x,
                      dy: -6 * _vm.sizeScale,
                      "font-size": 18 * _vm.sizeScale,
                      "stroke-width": 3 * _vm.sizeScale,
                      stroke: "white",
                      fill: "#333",
                      "paint-order": "stroke fill",
                      "font-weight": "bold",
                    },
                  },
                  [_vm._v("\n      " + _vm._s(_vm.truncatedLabel) + "\n    ")]
                ),
                _vm._v(" "),
                _c(
                  "tspan",
                  {
                    attrs: {
                      x: _vm.x,
                      dy: 14 * _vm.sizeScale,
                      "font-size": 14 * _vm.sizeScale,
                      "stroke-width": 4 * _vm.sizeScale,
                      stroke: "white",
                      "font-weight": "500",
                      fill: "#444",
                      "paint-order": "stroke fill",
                    },
                  },
                  [_vm._v("\n      (" + _vm._s(_vm.countDisplay) + ")\n    ")]
                ),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }